import { render, staticRenderFns } from "./setTags.vue?vue&type=template&id=71a0e77f&scoped=true"
import script from "./setTags.vue?vue&type=script&lang=js"
export * from "./setTags.vue?vue&type=script&lang=js"
import style0 from "./setTags.vue?vue&type=style&index=0&id=71a0e77f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a0e77f",
  null
  
)

export default component.exports